export enum BREAKPOINTS {
  mobile = 576,
  tablet = 768,
  desktop = 992,
  largeDesktop = 1200,
  largerDesktop = 1500,
}
